import { isConfigFlagEnabled } from '../config';
import { ALL_NUM_MTT_SEATS, ALL_NUM_SEATS } from '../types/sharedTypes';
import { isLocalhostEnvironment } from './utils';
const MAX_NUM_SEATS = 11;
const LIMITED_MAX_NUM_SEATS = 8;
export function getDefaultNumSeats() {
    if (isConfigFlagEnabled('limitMaxNumSeats')) {
        return LIMITED_MAX_NUM_SEATS;
    }
    return MAX_NUM_SEATS;
}
export function getAllNumSeatsOptions(isMtt) {
    if (isMtt) {
        return isLocalhostEnvironment() ? [...ALL_NUM_MTT_SEATS] : [4, 5];
    }
    return isConfigFlagEnabled('limitMaxNumSeats')
        ? ALL_NUM_SEATS.filter((currNumSeats) => currNumSeats <= LIMITED_MAX_NUM_SEATS)
        : [...ALL_NUM_SEATS];
}
